<template>
  <div class="layout">
    <el-container>
      <el-aside width="240px">
        <div class="menu-logo">
          <a href>
            <img src="../assets/images/logo.png" alt />
            <h1>LaClub积分商城</h1>
          </a>
        </div>
        <side-menu />
      </el-aside>
      <el-container class="main-wrapper" direction="vertical">
        <global-header />
        <el-main>
          <el-row>
            <el-col :span="24">
              <div class="breadcrumb-container">
                <breadcrumb />
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" class="main-row">
            <el-col :span="24">
              <transition name="el-fade-in" mode="out-in">
                <route-view />
              </transition>
            </el-col>
          </el-row>
        </el-main>
        <global-footer />
      </el-container>
    </el-container>
    <back-top />
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GlobalHeader from '@/components/GlobalHeader';
import GlobalFooter from '@/components/GlobalFooter';
import SideMenu from '@/components/Menu';
import RouteView from '@/layouts//RouteView.vue';
import BackTop from '@/components/BackTop';

export default {
  name: 'BasicLayout',
  components: {
    Breadcrumb,
    RouteView,
    GlobalHeader,
    GlobalFooter,
    SideMenu,
    BackTop,
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.layout
  display flex
  flex auto
  width 100%
  height auto
  min-height 100vh
  overflow-x hidden
  flex-direction row
  .menu-logo
    position relative
    height 64px
    padding-left 24px
    overflow hidden
    line-height 64px
    background #002140
    cursor pointer
    transition all 0.3s
    img
      display: inline-block;
      height: 32px;
      vertical-align: middle;
    h1
      display: inline-block;
      margin: 0 0 0 12px;
      color: #fff;
      font-weight: 600;
      font-size: 18px;
      font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
      vertical-align: middle;
  .main-wrapper
    margin 0 auto
    align-items stretch
    .el-main
      flex-column()
      padding 0
      .main-row
        flex 1
        margin 0 24px 24px 24px
        padding 24px 32px
        background-color #ffffff
      .breadcrumb-container
        width 100%
        height 50px
        flex-row-nowrap()
        background #FFFFFF
        border-radius 4px
        padding 0 20px
        margin-bottom 20px
</style>
